import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/maps',
    name: 'maps',
    component: () => import('../views/MapsView.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/SearchView.vue')
  },
  {
    path: '/attract',
    name: 'attract',
    component: () => import('../views/news/ListView.vue')
  },
  {
    path: '/attract/details',
    name: 'attract',
    component: () => import('../views/news/DetailView.vue')
  },
  {
    path: '/attract/maps',
    name: 'attract',
    component: () => import('../views/news/MapView.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service/ListView.vue')
  },
  {
    path: '/service/details',
    name: 'service',
    component: () => import('../views/service/DetailView.vue')
  },
  {
    path: '/building',
    name: 'building',
    component: () => import('../views/building/ListView.vue')
  },
  {
    path: '/building/more',
    name: 'building',
    component: () => import('../views/building/MoreView.vue')
  },
  {
    path: '/building/details',
    name: 'building',
    component: () => import('../views/building/DetailView.vue')
  },
  {
    path: '/device',
    name: 'device',
    component: () => import('../views/device/DeviceView.vue')
  },
  {
    path: '/device/details',
    name: 'device',
    component: () => import('../views/device/DetailView.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/device/ProductView.vue')
  },
  {
    path: '/people',
    name: 'people',
    component: () => import('../views/device/PeopleView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/users/index',
    name: 'users',
    component: () => import('../views/users/IndexView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
